'use client';


/** Imports */
import React from 'react';
import {signOut} from 'next-auth/react';
import {useTranslations} from 'next-intl';
import {MdExitToApp} from 'react-icons/md';
import styles from '@/app/[locale]/dashboard/(root)/page.module.css';


/** Component */
export default function SignOut() {

    // Hooks
    const tCommon = useTranslations('common');

    // Event handler
    async function handleSignOut() {
        await signOut();
    }


    // Render
    return (
        <button
            type="button"
            className={styles.headButton}
            onClick={handleSignOut}
            aria-label={tCommon('ariaLabels.signOut')}
        >
            <MdExitToApp/>
        </button>
    );
}
